import { useRef, useEffect, useCallback } from 'react';
import DateInput from './DateInput';
import SSN from './SSN';
import Citizenship from './Citizenship';

const Applicant = ({page, applicantRef, i, formData, setFormData, setValidationErrors}) => {
    // const year = new Date().getFullYear();
    const applicantName = 'applicant_' + i + '_name';
    const applicantDOB = 'applicant_' + i + '_dob';
    const applicantHasSSN = 'applicant_' + i + '_has_ssn';
    const applicantNoSSN = 'applicant_' + i + '_no_ssn';
    const applicantSSNSection = 'applicant_' + i + '_ssn_section';
    const applicantSSN = 'applicant_' + i + '_ssn';
    const applicantGender = 'applicant_' + i + '_gender';
    const applicantLivesWith = 'applicant_' + i + '_lives_with';
    const applicantRelationship = 'applicant_' + i + '_relationship';
    const applicantTaxStatus = 'applicant_' + i + '_tax_status';
    // const applicantFilingJointly = 'applicant_' + i + '_filing_jointly';
    // const applicantIsDependent = 'applicant_' + i + '_is_dependent';
    const applicantAddressAuto = 'applicant_' + i + '_address_auto';
    const applicantAddress = 'applicant_' + i + '_address';
    const applicantAddress2 = 'applicant_' + i + '_address2';
    const applicantCity = 'applicant_' + i + '_city';
    const applicantCounty = 'applicant_' + i + '_county';
    const applicantState = 'applicant_' + i + '_state';
    const applicantZip = 'applicant_' + i + '_zip';
    const applicantCurrentlyEnrolled = 'applicant_' + i + '_currently_enrolled';
    const applicantWillExpire = 'applicant_' + i + '_will_expire';
    const applicantOfferThroughJob = 'applicant_' + i + '_offer_through_job';

    const isRequired = false;

    // const filingJointlyRef = useRef();
    const applicantAddressRef = useRef();
    const applicantAddressInputRef = useRef();
    const noSSNAssertionRef = useRef();

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };
    const handleCheck = (event) => {
        const { name } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: event.target.checked ? 'Yes' : 'No' }));
    };
    const handleHasSSN = (event) => {
        setFormData((prevFormData) => ({ ...prevFormData, [applicantHasSSN]: event.target.checked ? 'Yes' : 'No' }));
        setFormData((prevFormData) => ({ ...prevFormData, [applicantNoSSN]: event.target.checked ? '' : prevFormData[applicantNoSSN] }));
        setFormData((prevFormData) => ({ ...prevFormData, [applicantSSN]: event.target.checked ? prevFormData[applicantSSN] : '' }));
        noSSNAssertionRef.current.style.display = event.target.checked ? 'none' : 'block';
        document.getElementById(applicantSSNSection).style.display = event.target.checked ? 'block' : 'none';
        document.getElementById(applicantNoSSN).required = event.target.checked ? false : true;
    };
    const handleNoSSN = (event) => {
        let label = document.getElementById(applicantNoSSN).nextSibling.innerHTML;
        setFormData((prevFormData) => ({ ...prevFormData, [applicantNoSSN]: event.target.checked ? label : '' }));
    };

    const handleLivesWith = (event) => {
        const { name } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: event.target.checked ? 'Yes' : 'No' }));
        if (event.target.checked) {
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddressAuto]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddress]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddress2]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCity]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCounty]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantState]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantZip]: '' }));
        }
    }
    const handleRelationship = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
        setFormData((prevFormData) => ({ ...prevFormData, [applicantTaxStatus]: value === 'Spouse' ? 'Filing jointly' : 'Dependent' }));
    }
    const handleCurrentlyEnrolled = (event) => {
        const enrolled = event.target.checked ? 'Yes' : 'No';
        setFormData((prevFormData) => ({ ...prevFormData, [applicantCurrentlyEnrolled]: enrolled }));
        if (enrolled === 'Yes') {
            document.getElementById(applicantWillExpire).style.display = 'block';
        }
        else {
            setFormData((prevFormData) => ({ ...prevFormData, [applicantWillExpire]: 'No' }));
            document.getElementById(applicantWillExpire).style.display = 'none';
        }
    }

    const parseApplicantAddress = useCallback((place) => {
        if (place) {
            let stNum = place.address_components.find((x) => x.types[0] === "street_number");
            let cityComponent = place.address_components.find((x) => x.types[0] === "locality");
            if (cityComponent === undefined) { 
                cityComponent = place.address_components.find((x) => x.types[0] === "administrative_area_level_3"); 
            }

            const streetNumber = stNum !== undefined ? stNum.short_name + ' ' : '';                
            const streetName = place.address_components.find((x) => x.types[0] === "route").short_name;
            const city = cityComponent !== undefined ? cityComponent.short_name : '';
            const county = place.address_components.find((x) => x.types[0] === "administrative_area_level_2").short_name;
            const state = place.address_components.find((x) => x.types[0] === "administrative_area_level_1").short_name;
            const zip = place.address_components.find((x) => x.types[0] === "postal_code").short_name;
    
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddressAuto]: document.getElementById(applicantAddressAuto).value }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddress]: streetNumber + streetName }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantAddress2]: '' }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCity]: city }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantCounty]: county }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantState]: state }));
            setFormData((prevFormData) => ({ ...prevFormData, [applicantZip]: zip }));

            console.log({ place });
        }
    }, [setFormData, applicantAddressAuto, applicantAddress, applicantAddress2, applicantCity, applicantCounty, applicantState, applicantZip]);

    useEffect(() => {
        if (page === 2 && formData[applicantLivesWith] !== 'Yes' && formData[applicantAddress] === '' && applicantAddressRef.current !== undefined) {
            applicantAddressRef.current = new window.google.maps.places.Autocomplete(
                applicantAddressInputRef.current,
                {
                    componentRestrictions: { country: "us" },
                    fields: ["address_components", "name"],
                    types: ["address"]
                }
            );
            applicantAddressRef.current.addListener("place_changed", async function() {
                const place = await applicantAddressRef.current.getPlace();
                parseApplicantAddress(place, false);
            });
        }
    }, [page, parseApplicantAddress, formData, applicantLivesWith, applicantAddress, applicantAddressRef, applicantAddressInputRef]);

    return (
        <div className="Applicant" ref={applicantRef} style={formData.how_many_others >= i ? { display: 'block' } : { display: 'none'}}>
            <h2>{formData[applicantName] !== '' ? formData[applicantName] : 'Other Applicant'}</h2>
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor={applicantName}>Full name:</label>
                <input className="QuestionInput" type="text" placeholder="First and Last name" id={applicantName} name={applicantName} value={formData[applicantName]} onChange={handleChange} required={isRequired} />
            </div>
            <DateInput label="Date of Birth:" fieldName={applicantDOB} isRequired={isRequired} formData={formData} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor={applicantGender}>Gender:</label>
                <select className="QuestionInput" id={applicantGender} name={applicantGender} value={formData[applicantGender]} onChange={handleChange} required={isRequired}>
                    <option value="">Select</option>
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                    <option value="Non-binary">Non-binary</option>
                </select>
            </div>
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor={applicantRelationship}>Relationship:</label>
                <select className="QuestionInput" id={applicantRelationship} name={applicantRelationship} value={formData[applicantRelationship]} onChange={handleRelationship} required={isRequired}>
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="OtherRelative">Other relative (by blood or marriage)</option>
                    <option value="Unrelated">Unrelated (Not by blood or marriage)</option>
                </select>
            </div>
            <div className="QuestionCheckbox">
                <input type="checkbox" id={applicantLivesWith} name={applicantLivesWith} value={formData[applicantLivesWith]} checked={formData[applicantLivesWith] === 'Yes'} onChange={handleLivesWith}/>
                <label htmlFor={applicantLivesWith}>{formData[applicantLivesWith] === 'Yes' ? formData[applicantName].split(' ')[0] + ' lives with ' + formData.applicant_name.split(' ')[0] : 'Remove this address' }</label>
            </div>
            <div className="QuestionBox" ref={applicantAddressRef} style={{display: (formData[applicantLivesWith] !== 'Yes' && formData[applicantAddress] === '') ? 'block' : 'none'}}>
                <label className="QuestionLabel" htmlFor={applicantAddressAuto}>Address:</label>
                <input className="AddressAutocomplete QuestionInput" id={applicantAddressAuto} name={applicantAddressAuto} ref={applicantAddressInputRef} required={formData[applicantLivesWith] !== 'Yes' && formData[applicantAddress] === ''} />
            </div>
            <div className="AddressFields" style={{display: (formData[applicantLivesWith] !== 'Yes' && formData[applicantAddress] !== '') ? 'flex' : 'none'}}>
                <div>
                    <div className="AddressField">
                        <label htmlFor={applicantAddress}>Street Address:</label>
                        <input className="AddressInput" id={applicantAddress} name={applicantAddress} value={formData[applicantAddress]} onChange={handleChange} required={formData[applicantLivesWith] !== 'Yes'} />
                    </div>
                    <div className="AddressField">
                        <label htmlFor={applicantAddress2}>Unit/Apt#:</label>
                        <input className="AddressInput" id={applicantAddress2} name={applicantAddress2} value={formData[applicantAddress2]} onChange={handleChange} required={false}/>
                    </div>
                    <div className="AddressField">
                        <label htmlFor={applicantCity}>City:</label>
                        <input className="AddressInput" id={applicantCity} name={applicantCity} value={formData[applicantCity]} onChange={handleChange} required={formData[applicantLivesWith] !== 'Yes'} />
                    </div>
                </div>
                <div>
                    <div className="AddressField">
                        <label htmlFor={applicantState}>State:</label>
                        <input className="AddressInput" id={applicantState} name={applicantState} value={formData[applicantState]} onChange={handleChange} required={formData[applicantLivesWith] !== 'Yes'} />
                    </div>
                    <div className="AddressField">
                        <label htmlFor={applicantZip}>Zip:</label>
                        <input className="AddressInput" id={applicantZip} name={applicantZip} value={formData[applicantZip]} onChange={handleChange} required={formData[applicantLivesWith] !== 'Yes'} />
                    </div>
                    <div className="AddressField">
                        <label htmlFor={applicantCounty}>County:</label>
                        <input className="AddressInput" id={applicantCounty} name={applicantCounty} value={formData[applicantCounty]} onChange={handleChange} required={formData[applicantLivesWith] !== 'Yes'} />
                    </div>
                </div>
            </div>
            <div className="QuestionCheckbox">
                <input type="checkbox" id={applicantHasSSN} name={applicantHasSSN} value={formData[applicantHasSSN]} checked={formData[applicantHasSSN] === 'Yes'} onChange={handleHasSSN}/>
                <label htmlFor={applicantHasSSN}>{formData[applicantName].split(' ')[0]} has a Social Security Number</label>
            </div>
            <div className="QuestionCheckbox" ref={noSSNAssertionRef} style={{ display: formData[applicantHasSSN] === 'Yes' ? 'none' : 'block' }}>
                <input type="checkbox" id={applicantNoSSN} name={applicantNoSSN} checked={formData[applicantNoSSN] !== ''} onChange={handleNoSSN}/>
                <label htmlFor={applicantNoSSN}>I attest that {formData[applicantName]} doesn't have an SSN, because they have never been issued an SSN by the Social Security adminisration</label>
            </div>
            <div className="QuestionBox" id={applicantSSNSection} style={{ display: formData[applicantHasSSN] === 'Yes' ? 'block' : 'none' }}>
                <SSN fieldName={applicantSSN} formData={formData} isRequired={isRequired} setFormData={setFormData} setValidationErrors={setValidationErrors} />
            </div>
            <div className="QuestionCheckbox">
                <input type="checkbox" id={applicantOfferThroughJob} name={applicantOfferThroughJob} value={formData[applicantOfferThroughJob]} checked={formData[applicantOfferThroughJob] === 'Yes'} onChange={handleCheck}/>
                <label htmlFor={applicantOfferThroughJob}>{formData[applicantName].split(' ')[0]} is offered health insurance through a job</label>
            </div>
            <div className="QuestionCheckbox">
                <input type="checkbox" id={applicantCurrentlyEnrolled} name={applicantCurrentlyEnrolled} value={formData[applicantCurrentlyEnrolled]} checked={formData[applicantCurrentlyEnrolled] === 'Yes'} onChange={handleCurrentlyEnrolled}/>
                <label htmlFor={applicantCurrentlyEnrolled}>{formData[applicantName].split(' ')[0]} is currently enrolled in a health insurance plan</label>               
            </div>
            <div className="QuestionBox" id={applicantWillExpire} style={{ display: formData[applicantCurrentlyEnrolled] === 'Yes' ? 'flex' : 'none' }}>
                <div>
                    <label className="QuestionLabel" htmlFor={applicantWillExpire}>Will {formData[applicantName]}'s coverage end in the next 60 days?</label>
                </div>
                <div>
                    <input type="radio" id={applicantWillExpire + '_yes'} name={applicantWillExpire} value="Yes" checked={formData[applicantWillExpire] === 'Yes'} onChange={handleChange} required={isRequired && formData[applicantWillExpire] === 'Yes'}/>
                    <label htmlFor={applicantWillExpire + '_yes'}>Yes</label>
                    <input type="radio" id={applicantWillExpire + '_no'} name={applicantWillExpire} value="No" checked={formData[applicantWillExpire] === 'No'} onChange={handleChange} required={isRequired && formData[applicantWillExpire] === 'Yes'}/>
                    <label htmlFor={applicantWillExpire + '_no'}>No</label>
                </div>
            </div>
            <Citizenship i={i} formData={formData} setFormData={setFormData} />
        </div>
    );
}

export default Applicant;
